<div class="truck" [ngClass]="{'selected': truck == selected}">
  <sc-padding>
    <sc-flex>
      <div>{{truck.numberPlate}}</div>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-action-icon (click)="onDelete()" *ngIf="editable" iconClass="fa-trash"></sc-action-icon>
    </sc-flex>
  </sc-padding>
</div>
